export default {
  // 自定义
  custom: {
    audioUpload: '音频上传',
    checkbox: '多选',
    dateTime: '日期',
    fileUpload: '附件上传',
    imageUpload: '单图上传',
    input: '单行文本',
    multiImageUpload: '多图上传',
    radio: '单选',
    select: '选择框',
    textarea: '多行文本',
    ueditor: '富文本',
    videoUpload: '视频上传'
  },
  // 快速自定义
  fastCustom: {
    address: '省市区',
    age: '年龄',
    birthday: '生日',
    city: '城市',
    email: '邮箱',
    fax: '传真',
    identity: '身份证',
    mobile: '手机',
    organize: '组织',
    phone: '电话',
    realname: '真名',
    sex: '性别'
  },
  // 栏目默认
  columnDefault: {
    accessPath: '访问路径',
    allowPost: '是否可投稿',
    browseSetting: '浏览器设置',
    columnDesc: '栏目描述',
    columnImage: '栏目图片',
    columnMTemplate: '手机模板',
    columnName: '栏目名称',
    columnPCTemplate: 'PC模板',
    commentSetting: '评论设置',
    contentTemplate: '内容模板',
    outsideLink: '外链',
    pageSize: '每页多少',
    pagination: '是否分页',
    parentColumn: '上级栏目',
    seoDesc: 'seo描述',
    seoKeyword: 'seo关键字',
    seoTitle: 'seo标题',
    showInloop: '显示在栏目循环列表',
    workFlowSetting: '工作流设置'
  },
  // 内容默认
  contentDefault: {
    abstract: '摘要',
    author: '作者',
    browseSetting: '浏览器设置',
    column: '所属栏目',
    columnMTemplate: '手机模板',
    columnPCTemplate: 'pc模板',
    commentSetting: '评论设置',
    content: '正文',
    document: '文档文库',
    keyword: '关键字',
    offlineTime: '下线时间',
    outsideLink: '外链',
    postConent: '发文字号',
    releasePlatform: '发布平台',
    releaseTime: '发布时间',
    singleImage: '单图',
    source: '来源',
    subTitle: '子标题',
    tags: 'tag词',
    title: '标题'
  },
  // 会员默认
  vipDefault: {
    email: '邮箱',
    group: '会员组',
    level: '等级',
    mobile: '手机',
    password: '密码',
    point: '积分',
    realname: '真名',
    status: '状态',
    username: '真名'
  }
}
